import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bool, string, func, number } from 'prop-types'
import { productDataType, productsDataType } from 'models/propTypes'
import { getSelectedRenderItemId } from 'models/compositions/selectors'
import {
    getSelectedFurnitureSwappableItemsData,
    getSelectedSwapFurnitureData,
    getIsSwappablesLoading,
    getSelectedFurnitureData,
} from 'models/furniture/selectors'
import { getDesignSidepanelMode } from 'models/ui/selectors'
import { requestFurnitureSwappables as requestFurnitureSwappablesAction } from 'models/furniture/actions'
import { trackShowDetails as trackShowDetailsAction } from 'models/tracking/actions'
import { addToBag as addToBagAction } from 'models/bag/actions'
import SwapView from 'components/designSidepanel/SwapView'
import { PRODUCT_SWAP } from 'models/tracking/constants'
import { swapRenderItem as swapRenderItemAction } from 'models/compositions/actions'
import { getProductTrackingInfo } from 'models/tracking/utils'

const SwapViewContainer = ({
    swappableItemsData,
    selectedSwapFurnitureData,
    requestFurnitureSwappables,
    isLoading,
    mode,
    onToggle,
    trackShowDetails,
    selectedFurnitureData,
    onSwap,
    selectedId,
    addToBag,
}) => {
    const selectedSwapFurnitureId = (selectedSwapFurnitureData && selectedSwapFurnitureData.id) || null
    const isSwappableItemsNull = !swappableItemsData
    useEffect(() => {
        if (selectedSwapFurnitureId && isSwappableItemsNull && !isLoading) {
            requestFurnitureSwappables(selectedSwapFurnitureId)
        }
    }, [isSwappableItemsNull, selectedSwapFurnitureId])

    let trackShowDetailsCallback = null
    if (selectedSwapFurnitureData) {
        const trackingInfo = getProductTrackingInfo(selectedSwapFurnitureData)
        trackShowDetailsCallback = () => trackShowDetails(trackingInfo)
    }
    const onUndoSwap = (e) => {
        e.stopPropagation()
        // Swap back the original product, the swap anchor
        if (selectedId && selectedSwapFurnitureData) {
            const removedFurnitureId = selectedFurnitureData.id
            const { id: swappedFurnitureId } = selectedSwapFurnitureData

            const swappedInProductTrackingInfo = getProductTrackingInfo(selectedSwapFurnitureData)
            const swappedInTrackingInfo = {
                ...swappedInProductTrackingInfo,
                AddedFrom: PRODUCT_SWAP,
            }

            if (removedFurnitureId) {
                const removedProductTrackingInfo = getProductTrackingInfo(selectedFurnitureData)
                const removedTrackingInfo = {
                    ...removedProductTrackingInfo,
                    RemovedFrom: PRODUCT_SWAP,
                }

                const trackingInfo = {
                    swappedInTrackingInfo,
                    removedTrackingInfo,
                }
                onSwap(selectedId, swappedFurnitureId, trackingInfo)
            }
        }
    }

    const onAddToBag = () => {
        if (selectedFurnitureData) {
            const { localItemNumber, region, name: productTitle } = selectedFurnitureData
            const trackingInfo = getProductTrackingInfo(selectedFurnitureData)

            addToBag(localItemNumber, region, productTitle, trackingInfo)
        }
    }

    return (
        <SwapView
            selectedSwapFurnitureData={selectedSwapFurnitureData}
            swappableItemsData={swappableItemsData}
            isLoading={isLoading}
            mode={mode}
            onToggle={onToggle}
            trackShowDetails={trackShowDetailsCallback}
            selectedFurnitureData={selectedFurnitureData}
            onUndoSwap={onUndoSwap}
            addToBag={onAddToBag}
        />
    )
}

SwapViewContainer.defaultProps = {
    swappableItemsData: [],
    selectedSwapFurnitureData: null,
    onToggle: null,
    selectedFurnitureData: null,
    selectedId: null,
}

SwapViewContainer.propTypes = {
    swappableItemsData: productsDataType,
    selectedSwapFurnitureData: productDataType,
    selectedFurnitureData: productDataType,
    requestFurnitureSwappables: func.isRequired,
    isLoading: bool.isRequired,
    mode: string.isRequired,
    onToggle: func,
    trackShowDetails: func.isRequired,
    onSwap: func.isRequired,
    selectedId: number,
    addToBag: func.isRequired,
}

const mapStateToProps = (state) => ({
    selectedId: getSelectedRenderItemId(state),
    swappableItemsData: getSelectedFurnitureSwappableItemsData(state),
    selectedSwapFurnitureData: getSelectedSwapFurnitureData(state),
    selectedFurnitureData: getSelectedFurnitureData(state),
    isLoading: getIsSwappablesLoading(state),
    mode: getDesignSidepanelMode(state),
})

const mapDispatchToProps = {
    requestFurnitureSwappables: requestFurnitureSwappablesAction,
    trackShowDetails: trackShowDetailsAction,
    onSwap: swapRenderItemAction,
    addToBag: addToBagAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(SwapViewContainer)
